'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('I18n/components');

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

var _utils = require('MeetingsLib/utils/utils');

var _Big = require('UIComponents/elements/Big');

var _Big2 = _interopRequireDefault(_Big);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'ZeroState',

  propTypes: {
    profile: _react.PropTypes.instanceOf(_UserProfile2.default).isRequired,
    compact: _react.PropTypes.bool.isRequired
  },

  renderZeroStateText: function renderZeroStateText() {
    var profile = this.props.profile;

    var options = { fullName: (0, _utils.getLongDisplayName)(profile) };
    return _react2.default.createElement(_components.FormattedMessage, {
      message: 'prebook.timeOptions.zeroState',
      options: options
    });
  },
  render: function render() {
    var profile = this.props.profile;

    return _react2.default.createElement(
      'div',
      { className: 'text-center m-top-10 prebook-zero-state' },
      _react2.default.createElement(
        'h4',
        null,
        _react2.default.createElement(_components.FormattedMessage, { message: 'prebook.timeOptions.sorry' })
      ),
      _react2.default.createElement(
        _Big2.default,
        null,
        _react2.default.createElement(
          'p',
          null,
          this.renderZeroStateText()
        ),
        _react2.default.createElement(
          _UILink2.default,
          { href: 'mailto:' + profile.email },
          profile.email
        )
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/schedule/ZeroState.js
// module id = 214
// module chunks = 0